import React from 'react';

function maxAbs(values) {
  let max = 0;
  for (const value of values) {
    const n = Math.abs(Number(value));
    if (Number.isFinite(n) && n > max) max = n;
  }
  return max || 1;
}

export default function AssistantAnalysisChart({ chart }) {
  if (!chart || !Array.isArray(chart.datasets) || !chart.datasets.length) {
    return <p className="vp-asst-chart-empty">沒有可繪製的數值資料。</p>;
  }
  const labels = Array.isArray(chart.labels) ? chart.labels : [];
  const dataset = chart.datasets[0];
  const values = Array.isArray(dataset?.values) ? dataset.values.filter((n) => Number.isFinite(Number(n))).map(Number) : [];
  if (!values.length) {
    return <p className="vp-asst-chart-empty">沒有可繪製的數值資料。</p>;
  }
  const width = 360;
  const height = 160;
  const padL = 36;
  const padR = 12;
  const padT = 16;
  const padB = 28;
  const innerW = width - padL - padR;
  const innerH = height - padT - padB;
  const peak = maxAbs(values);
  const barW = Math.max(8, Math.min(36, innerW / values.length - 6));
  const gap = innerW / values.length;

  return (
    <figure className="vp-asst-chart" data-testid="assistant-analysis-chart">
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={dataset.label ? `${dataset.label} 數值圖` : '分析數值圖'}>
        <line x1={padL} y1={padT} x2={padL} y2={padT + innerH} stroke="#cbd5e1" />
        <line x1={padL} y1={padT + innerH} x2={padL + innerW} y2={padT + innerH} stroke="#cbd5e1" />
        {values.map((value, index) => {
          const x = padL + gap * index + (gap - barW) / 2;
          const h = Math.max(1, (Math.abs(value) / peak) * innerH);
          const y = value >= 0 ? padT + innerH - h : padT + innerH;
          const label = labels[index] != null ? String(labels[index]) : String(index + 1);
          return (
            <g key={`${label}-${index}`}>
              <rect
                className="vp-asst-chart-bar"
                data-testid="assistant-chart-bar"
                data-value={String(value)}
                data-label={label}
                x={x}
                y={y}
                width={barW}
                height={h}
                rx="3"
                fill="var(--vp-brand, #2563eb)"
              >
                <title>{`${label}: ${value}`}</title>
              </rect>
              <text x={x + barW / 2} y={padT + innerH + 14} textAnchor="middle" fontSize="9" fill="#5c6b7a">{label}</text>
              <text x={x + barW / 2} y={y - 4} textAnchor="middle" fontSize="10" fill="#1a2332">{value}</text>
            </g>
          );
        })}
      </svg>
      {chart.title || dataset.label ? <figcaption>{chart.title || dataset.label}</figcaption> : null}
    </figure>
  );
}
